import React, { createContext, useContext, useState, useEffect } from "react";
import axiosConfig from "../Service/AxiosConfig";
const safeStorage = {
  get(key) {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch {
      return null;
    }
  },
  set(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {}
  },
};

const LocationContext = createContext(null);

export const LocationProvider = ({ children }) => {
  const [location, setLocation] = useState(() => {
    return (
      safeStorage.get("user_location") || {
        address: "",
        city: "",
        latitude: null,
        longitude: null,
        address_id: null,
        source: null,
      }
    );
  });

  const [apiKey, setApiKey] = useState("");
  const [addressModalOpen, setAddressModalOpen] = useState(false);

  useEffect(() => {
    axiosConfig
      .get("/masters/googlemapkey/")
      .then((res) => setApiKey(res?.data?.results[0]?.key));
  }, []);
  useEffect(() => {
    if (location?.address) {
      safeStorage.set("user_location", location);
    }
  }, [location]);

  const detectLocation = () => {
    if (!navigator.geolocation || !apiKey) return;

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        try {
          const lat = pos.coords.latitude;
          const lng = pos.coords.longitude;

          const res = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`,
          );
          const data = await res.json();

          const components = data.results?.[0]?.address_components || [];

          const city =
            components.find((c) => c.types.includes("locality"))?.long_name ||
            components.find((c) =>
              c.types.includes("administrative_area_level_2"),
            )?.long_name ||
            "";

          setLocation({
            latitude: Number(lat),
            longitude: Number(lng),
            address: data.results?.[0]?.formatted_address || "",
            city,
            address_id: null,
            source: "Website",
          });
        } catch (e) {
          console.error("Location fetch failed", e);
        }
      },
      (err) => {
        console.log("Permission denied", err);
      },
    );
  };

  return (
    <LocationContext.Provider
      value={{
        location,
        setLocation,
        detectLocation,
        addressModalOpen,
        setAddressModalOpen,
      }}
    >
      {children}
    </LocationContext.Provider>
  );
};

export const useLocationContext = () => useContext(LocationContext);
